import styled, { css } from 'styled-components';

export const SectionContainer = styled.div<{
  backgroundImage: string;
  backgroundSize?: string;
  backgroundPosition?: string;
  darkOverlay?: boolean;
  gradientOverlay?: boolean;
  lighterOverlay?: boolean;
  middleOverlay?: boolean;
  greyedOverlay?: boolean;
  height?: string;
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  padding: 5rem 1rem;
  box-sizing: border-box;

  height: ${({ height }) => height ?? '650px'};
  width: 100%;

  background-image: url(${props => props?.backgroundImage});
  background-size: ${({ backgroundSize }) => backgroundSize ?? 'cover'};

  background-position: ${({ backgroundPosition }) =>
    backgroundPosition ?? 'center'};
  background-repeat: no-repeat;

  ${({ darkOverlay }) =>
    darkOverlay &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(39, 52, 61, 0.84);
        z-index: 1;
        pointer-events: none;
      }

      > * {
        position: relative;
        z-index: 2;
      }
    `}

  ${({ gradientOverlay }) =>
    gradientOverlay &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        opacity: 0.8;
        background: linear-gradient(
          0deg,
          rgba(39, 52, 61, 0.1) 24%,
          #27343d 56.78%
        );

        z-index: 1;
        pointer-events: none;
      }

      > * {
        position: relative;
        z-index: 2;
      }
    `}

  ${({ lighterOverlay }) =>
    lighterOverlay &&
    css`
      &::before {
        background: rgba(40, 39, 39, 0.4);
      }
    `}

    ${({ middleOverlay }) =>
    middleOverlay &&
    css`
      &::before {
        background: rgba(39, 52, 61, 0.84);
        background-blend-mode: multiply;
      }
    `}
  
  ${({ greyedOverlay }) =>
    greyedOverlay &&
    css`
      &::before {
        background: rgba(62, 82, 82, 0.4);
      }
    `}

  @media only screen and (max-width: ${({ theme }) =>
    theme.breakpoint.width768}) {
    background-size: cover;
    padding: 5rem 2rem;
  }
`;

export const Description = styled.div<{
  color?: string;
  fontWeight?: string;
  fontSize?: string;
}>`
  color: ${({ color, theme }) => color ?? theme.color.white};
  font-size: ${({ fontSize, theme }) => fontSize ?? theme.fontSize.size20};
  font-weight: ${({ fontWeight, theme }) =>
    fontWeight ?? theme.fontWeight.weight400};
  line-height: ${({ theme }) => theme.lineHeight.height150};

  margin-top: 2rem;
  margin-bottom: 2rem;
  text-align: center;
  max-width: 70rem;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
    margin-top: 1rem;
    margin-bottom: 2rem;
    width: 85%;
  }
`;

export const TextWrapper = styled.p<{ color?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1100px;
  width: 100%;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const TitleText = styled.h2<{ color: string; fontSize?: string }>`
  color: ${({ color, theme }) => color || theme.color.white};
  font-size: ${({ fontSize, theme }) => fontSize ?? theme.fontSize.size70};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  padding-bottom: 2rem;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    font-size: ${({ fontSize, theme }) => fontSize ?? theme.fontSize.size50};
    padding-bottom: 1rem;
    width: 100%;
  }
`;

export const UnderlineContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const Underline = styled.div<{
  color?: string;
}>`
  width: 160px;
  height: 0.4rem;
  background-color: ${({ color, theme }) => color ?? theme.color.white};
`;
